import { React, useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  AutoComplete,
  Tooltip
} from "antd";
import { Collapse } from 'antd';
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import { getPackagingDetails, savePackagingDetails, updatePackagingDetails, deletePackaging } from "../../../Services/packagingService";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { capital_letter } from "../../../Utils/helper/helper";
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const quantityTabArray = [
  {
    label: "Number of items",
    value: "reel_sheet"
  }, 
  {
    label: "Weight",
    value: "weight"
  },
];

const AddReelPackaging = (props) => {
  const scrollRef = useRef(null);
  const [form] = Form.useForm();
  const [orderQuantity, setOrderQuantity] = useState(props?.data ? props.data?.quantity_type : "reel_sheet");
  const [measurementData, setMeasurementData] = useState();  
  const [add, setAdd] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [packagingData, setPackagingData] = useState([]);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [modalPopUpData, setModalPopUpData] = useState();
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [isEditButtonEnabled, setIsEditButtonEnabled] = useState(false);

    useEffect(() => {
      (async () => {
        try{
          const unitData = await getUnitData();
          if(!unitData?.error){
            setMeasurementData(unitData);
            form.setFieldsValue({weightUnit: (props?.data && props?.data?.units) ? props.data.units.weight : unitData.data.units_management.weight.default});
          }
        } catch(err){
          console.log(err);
        }

        try{
          const resp = await getPackagingDetails();
          if (!resp?.data?.error) {
              setPackagingData(resp?.data?.data);
          }
        } catch(err){
          console.log(err);
        }
      })();
    }, []);

    const scrollToTop = () => {
      scrollRef.current.scrollIntoView();
    };

    const handleClose = () => {
      scrollToTop();
      form.resetFields();
      form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
      props.onClose();
    };

    const handleQuantityChange = (e) => {
      if(props?.actionType === "add"){
        form.setFieldsValue({weight: ""});
        form.setFieldsValue({quantity: ""});
        form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
      }
      setOrderQuantity(e.target.value);
      if(props?.data && props?.data?.quantity_type === "weight" && props?.actionType === "edit"){
        delete props?.data.quantity;
      } else{
        delete props?.data.weight;
      }
      if(props?.data && props?.data?.quantity_type === "weight" && props?.actionType === "edit"){
        form.setFieldsValue({weightUnit: props?.data?.units?.weight});
        form.setFieldsValue({weight: props?.data?.weight});
      }
      if(props?.data && props.data.quantity_type === "reel_sheet" && props?.actionType === "edit"){
        form.setFieldsValue({quantity: props?.data?.quantity});
      }
    };

    const onPackagingNameChange = (e) => {
      setNameErr(false);
      packagingData?.forEach((item) =>{
        if(props?.actionType === "edit"){
          if(item.name?.toString()?.toLowerCase () === e.target.value?.toString().toLowerCase() && 
          item.id !== props?.data?.id){
            setNameErr(true);
          }
        } else{
          if(item.name?.toString()?.toLowerCase () === e.target.value?.toString().toLowerCase()){
            setNameErr(true);
          }
        }
      });
    }

    const showToaster = () => {
      setVisibleToaster(true);
      setTimeout(() => setVisibleToaster(false), 3000);
    };

    const onFinish = (e) => {
      if(props?.actionType === "add"){
        let addPackagingTypeReq = {
          name: capital_letter(e.packagingName),
          description: e.packagingDesc,
          quantity_type: orderQuantity,
          ...orderQuantity === "weight" ? {weight : e.weight} : { quantity : e.quantity},
          type: props?.type,
          remarks: e.remarks? e.remarks : "",
          status: "active",
          ...orderQuantity === "weight" && {units: {weight: e.weightUnit}}
        };
        if(add){
          savePackagingDetails(addPackagingTypeReq).then((response) => {
            setTimeout(() => {
              setActionToaster({
                error: response?.data?.error,
                msg: response?.data?.msg,
              });
              form.resetFields();
              scrollToTop();
              setOrderQuantity("reel_sheet");
              form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
              showToaster();
            }, 0);
        }).catch((error) => {
          console.log("Error in adding new packaging config:", error);
          // props.toasterAction({
          //   error: error.response.error,
          //   msg: error.response.data.msg,
          // });
          // props.showToaster();
          // props.onClose();

          if(error?.response?.status == 500){
            props.toasterAction({
              error: true,
              msg: "Something went wrong. Please try again",
            });
          } else{
             props.toasterAction({
              error: true,
              msg: error?.response?.data?.msg,
            });     
          }

          props.showToaster();
          props.onClose();
        });
        } else{
          savePackagingDetails(addPackagingTypeReq).then((response) => {
              props.toasterAction({
                error: response?.data?.error,
                msg: response?.data?.msg,
              });
              form.resetFields();
              setOrderQuantity("reel_sheet");
              form.setFieldsValue({weightUnit: measurementData.data.units_management.weight.default});
              props.showToaster();
              props.onClose();
          }).catch((error) => {
            console.log("Error in adding new packaging config:", error);
            // props.toasterAction({
            //   error: error.response.error,
            //   msg: error.response.msg,
            // });
            // props.showToaster();
            // props.onClose();

            if(error?.response?.status == 500){
              props.toasterAction({
                error: true,
                msg: "Something went wrong. Please try again",
              });
            } else{
              props.toasterAction({
                error: true,
                msg: error?.response?.data?.msg,
              });
            }
            
            props.showToaster();
            props.onClose();
            });
        }
      }
      if(props?.actionType === "edit"){
        let editPackagingTypeReq = {
          name: capital_letter(e.packagingName),
          description: e.packagingDesc,
          quantity_type: orderQuantity,
          ...orderQuantity === "weight" ? {weight : e.weight} : { quantity : e.quantity},
          type: props?.type,
          remarks: e.remarks? e.remarks : "",
          status: props?.data?.status,
          ...orderQuantity === "weight" && {units: {weight: e.weightUnit}}
        };
        updatePackagingDetails(props?.data?.id, editPackagingTypeReq).then((response) => {
          props.toasterAction({
            error: response?.data?.error,
            msg: response?.data?.msg,
          });
          form.resetFields();
          setOrderQuantity(props?.data ? props.data.quantity_type : "reel_sheet");
          form.setFieldsValue({weightUnit: props?.data && props.data.units ? props.data.units.weight : measurementData.data.units_management.weight.default});
          props.showToaster();
          props.onClose();
        }).catch((error) => {
          console.log("Error in updating packaging config:", error);
          // props.toasterAction({
          //   error: error.response.error,
          //   msg: error.response.msg,
          // });
          // props.showToaster();
          // props.onClose();
            if(error?.response?.status == 500){
              props.toasterAction({
                error: true,
                msg: "Something went wrong. Please try again",
              });
            } else{
              props.toasterAction({
                error: true,
                msg: error?.response?.data?.msg,
              });
            }
            
            props.showToaster();
            props.onClose();
        });
        
      }
    };

    const onFinishFailed = () => {
      scrollToTop();
    };

    const handleDeletePackagingType = () => {
      setModalPopUpData({
        title: "Delete Packaging type?",
        content:
          `You are about to delete this ${props?.type} packaging type ${props?.data?.name}. Once deleted, it cannot be recovered. Are you sure you want to continue?`,
        image: warning,
        key: "packaging",
        action: "delete",
        data: props?.data,
      });
      modalShow();
    };

    const modalConfirm = async () => {
      if (modalPopUpData.action === "delete")
        if (modalPopUpData.key === "packaging"){
          deletePackagingHandler(modalPopUpData.data);
        }
        setIsVisibleModal(false);
        setModalPopUpData();
    };

    const modalShow = () => {
      setIsVisibleModal(true);
    };
  
    const modalClose = () => {
      setIsVisibleModal(false);
    };

    const deletePackagingHandler = async (data) => {
      try {
        const response = await deletePackaging(data?.id);
        if (!response.data?.error) {
          props.toasterAction({
            error: response?.data?.error,
            msg: response?.data?.msg,
          });
          props.showToaster();
          props.onClose();
        }
      } catch (error) {
        console.log("Error in deleting packaging config:", error);
        // props.toasterAction({
        //       error: error,
        //       msg: error.response.data.msg,
        // });
        // props.showToaster();
        // props.onClose();

        if(error?.response?.status == 500){
          props.toasterAction({
            error: true,
            msg: "Something went wrong. Please try again",
          });
        } else{
          props.toasterAction({
            error: true,
            msg: error?.response?.data?.msg,
          });
        }
        
        props.showToaster();
        props.onClose();
      }
    };

    const onFormChange = async() => {
      if (!isEditButtonEnabled)
        setIsEditButtonEnabled(true);
    };

    return (measurementData) ? (
        <RightDrawerSidebar
        type="packaging_config"
        title={props.actionType === "add" ? (props.type === "reel" ? "Add New Reel Packaging Type" : "Add New Sheet Packaging Type") : props?.data?.name }
        subtitle=""
        visible={props.visible}
        onClose={handleClose}
      >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft" ref={scrollRef}>
        {visibleToaster ? (
            <AlertContainer
              color={actionToaster.error ? "red" : "green"}
              icon={actionToaster.error ? alertRed : alertGreen}
              msg={actionToaster.msg}
            />
          ) : null}
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
                onChange={onFormChange}
              >
                <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Name & Description of the Packaging</h5>
                      <p>The packaging type will be identified by this unique name</p>
                    </div>
                    <Form.Item 
                    name="packagingName" 
                    className="dBlock"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                      {
                        max: 50,
                        message: "The name can have a maximum of 50 characters",
                      },
                      {
                        validator(_, value) {
                          if(nameErr){
                            return Promise.reject("The packaging type name should be unique");
                          } else{
                            return Promise.resolve();
                          }
                        },
                      },
                    ]} 
                    initialValue={props?.data? props.data.name : ""}>
                      <Input
                      placeholder="Enter the name of packaging"
                      style={{ textTransform: "capitalize" }}
                      onChange={onPackagingNameChange}
                      disabled={props?.actionType === "view"}/>
                      
                    </Form.Item>

                    <div className="titleWithText">
                      <p>Description of specifications of this packaging type</p>
                    </div>
                     <Form.Item
                        name="packagingDesc"
                        className=""
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            max: 150,
                            message: "The description can have a maximum of 150 characters",
                          },
                        ]}
                        initialValue={props?.data? props.data.description : ""}>
                        <TextArea
                          maxLength={150}
                          style={{ height: 90}}
                          placeholder="Enter the description of packaging"
                          disabled={props?.actionType === "view"}/>
                    </Form.Item>
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order Quantity</h5>
                    <p>Order format and quantity</p>
                  </div>
                  <div className=" switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      options={quantityTabArray}
                      optionType="button"
                      buttonStyle="solid"
                      value={orderQuantity}
                      onChange={handleQuantityChange}
                      disabled={props?.actionType === "view"}/>
                  </div>
                  {orderQuantity === "weight" ? (
                    <>
                      <div className="subTitleWithText">
                          <p>Weight of the packaging type</p>
                      </div>
                      <div style={{ position: "relative" }}>
                        <Row className="centerAlign justifyCSBetween">
                          <Col span={13}>
                          <div className="boxFormType">
                            <Form.Item
                                  name="weight"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric characters are allowed upto 3 decimal point",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={props?.data ? props.data.weight : ""}
                                >
                                  <Input
                                    placeholder="Enter weight"
                                    disabled={props?.actionType === "view"}/>
                                </Form.Item>
                          </div>
                          </Col>
                          <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                name="weightUnit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={props?.data ? weightUnit[props?.data?.weight]?.displayName : ""}
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw/>}
                                  disabled={props?.actionType === "view"}
                                  onChange={onFormChange}
                                >
                                  {measurementData.data.units_management.weight.data?.map((unitItem) => (
                                    <Option key={unitItem} value={unitItem}>
                                      {weightUnit[unitItem]?.displayName}
                                    </Option>
                                  ))}
                                </Select>
                                </Form.Item>
                              </div>
                            </Col>
                        </Row>
                      </div>
                    </>
                  ) : (<>
                    <div className="subTitleWithText">
                      <p>{`Number of item in the packaging type`}</p>
                    </div>
                    <Form.Item
                        name="quantity"
                        rules={[
                          { 
                            required: true, 
                            message: "This field is required" 
                          },
                          {
                            pattern: new RegExp(/^[0-9]+$/),
                            message: "Only Numeric characters are allowed",
                          },
                        ]}
                        className=""
                        initialValue={props?.data ? props.data.quantity : ""}
                      >
                        <Input
                          placeholder="Enter quantity"
                          disabled={props?.actionType === "view"}/>
                      </Form.Item>
                    </>
                  )}
                </div>

                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Remarks</h5>
                    <p>Any other Information related to this packaging type</p>
                  </div>
                  <Form.Item
                    name="remarks"
                    className=""
                    initialValue={props?.data ? props.data.remarks : ""}
                  >
                    <TextArea
                      maxLength={200}
                      style={{ height: 90 }}
                      placeholder="Enter Remarks"
                      disabled={props?.actionType === "view"}/>
                  </Form.Item>
                </div>

                {props.actionType === "add" && (<div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn"
                      onClick={() => setAdd(false)}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Save{" "}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="themeBtn noBg"
                      htmlType="submit"
                      onClick={() => setAdd(true)}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />{" "}
                      Add & add new packaging{" "}
                    </Button>
                  </Form.Item>
                </div>)}

                {props.actionType === "edit" && (<div className="buttonFlex fixedBtm">
                  <Form.Item>
                  <Button
                      htmlType="submit"
                      className="themeBtn"
                      disabled={!isEditButtonEnabled}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Save Changes
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button className="themeBtn noBg" onClick={handleDeletePackagingType}>
                      <Iconmoon icon="delete" size={16} color="#EA655B" />
                      Delete {" "}
                    </Button>
                  </Form.Item>
                </div>)}
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={modalPopUpData && modalPopUpData.image} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>{modalPopUpData && modalPopUpData.title}</span>
          <p>{modalPopUpData && modalPopUpData.content}</p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
    ) : null;
};
export default AddReelPackaging;
